import env from '@/env';
import { useTranslation } from 'react-i18next';

export const useAssistNavigationItems = () => {
  const { t } = useTranslation(['navigation']);

  return [
    {
      id: 'go-to-assist',
      label: t('crossPlatform.secondary.goToAssist'),
      route: 'https://statsbombhelp.zendesk.com/hc',
      target: '_blank' as const,
    },
    {
      id: 'technical-glossary',
      label: t('crossPlatform.secondary.technicalGlossary'),
      route: `https://${env.VITE_IQ_DOMAIN}/help/sbdata-glossary`,
    },
  ];
};
